/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MergeMode } from './MergeMode';
import {
    MergeModeFromJSON,
    MergeModeFromJSONTyped,
    MergeModeToJSON,
    MergeModeToJSONTyped,
} from './MergeMode';

/**
 * 
 * @export
 * @interface FinalizeUploadsRequestDto
 */
export interface FinalizeUploadsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof FinalizeUploadsRequestDto
     */
    joinKeyColumn?: string | null;
    /**
     * 
     * @type {MergeMode}
     * @memberof FinalizeUploadsRequestDto
     */
    mergeMode?: MergeMode;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FinalizeUploadsRequestDto
     */
    fileJoinKeyOverrides?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the FinalizeUploadsRequestDto interface.
 */
export function instanceOfFinalizeUploadsRequestDto(value: object): value is FinalizeUploadsRequestDto {
    return true;
}

export function FinalizeUploadsRequestDtoFromJSON(json: any): FinalizeUploadsRequestDto {
    return FinalizeUploadsRequestDtoFromJSONTyped(json, false);
}

export function FinalizeUploadsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeUploadsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'joinKeyColumn': json['joinKeyColumn'] == null ? undefined : json['joinKeyColumn'],
        'mergeMode': json['mergeMode'] == null ? undefined : MergeModeFromJSON(json['mergeMode']),
        'fileJoinKeyOverrides': json['fileJoinKeyOverrides'] == null ? undefined : json['fileJoinKeyOverrides'],
    };
}

export function FinalizeUploadsRequestDtoToJSON(json: any): FinalizeUploadsRequestDto {
    return FinalizeUploadsRequestDtoToJSONTyped(json, false);
}

export function FinalizeUploadsRequestDtoToJSONTyped(value?: FinalizeUploadsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'joinKeyColumn': value['joinKeyColumn'],
        'mergeMode': MergeModeToJSON(value['mergeMode']),
        'fileJoinKeyOverrides': value['fileJoinKeyOverrides'],
    };
}

